import { render, staticRenderFns } from "./CourseCenter.vue?vue&type=template&id=4f10da47&scoped=true&"
import script from "./CourseCenter.vue?vue&type=script&lang=js&"
export * from "./CourseCenter.vue?vue&type=script&lang=js&"
import style0 from "./CourseCenter.vue?vue&type=style&index=0&id=4f10da47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f10da47",
  null
  
)

export default component.exports